@if (isAdmin) {
  <div class="btn-container">
    <button pButton pRipple type="button" label="New Order" icon="pi pi-plus"
    (click)="openOrderDialog('create')"></button>
  </div>
}

<div class="table-container">
  <p-table #dt [value]="allProviderOrders" styleClass="p-datatable" [rowHover]="true" [rows]="5"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="medName">
          <div class="flex justify-content-between align-items-center">
            Medication
            <p-sortIcon field="medName"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="dosage">
          <div class="flex justify-content-between align-items-center">
            Dosage
            <p-sortIcon field="dosage"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="route">
          <div class="flex justify-content-between align-items-center">
            Route
            <p-sortIcon field="route"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="type">
          <div class="flex justify-content-between align-items-center">
            Type
            <p-sortIcon field="type"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="administeredString">
          <div class="flex justify-content-between align-items-center">
            Administered
            <p-sortIcon field="administeredString"></p-sortIcon>
          </div>
        </th>

        <th>
          <div class="flex justify-content-between align-items-center">
            <div class="actions-title-container">Actions</div>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="p-selectable-row">
        <td>
          {{ order.medName }}
        </td>
        <td>
          {{ order.dosage }}
        </td>
        <td>
          {{ order.route }}
        </td>
        <td>
          {{ order.type }}
        </td>
        <td>
          {{ order.administeredString }}
        </td>
        <td class="actions-container">
          <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View order"
          (click)="viewOrder(order)"></button>
          @if (isAdmin) {
            <button pButton type="button" class="p-button-warning" icon="pi pi-pencil" pTooltip="Edit order"
            (click)="openOrderDialog('edit', order)"></button>
            <button pButton type="button" class="p-button-danger" icon="pi pi-trash" pTooltip="Delete Order"
            (click)="deleteOrder(order)"></button>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No orders found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>